<fieldset *ngIf="!isToggle(attribute)">
  <legend style="display: none">{{ attribute.label }}</legend>
  <div id="{{ createAttributeIdForConfigurator(attribute) }}">
    <div *ngIf="withQuantity" class="cx-attribute-level-quantity-price">
      <cx-configurator-attribute-quantity
        (changeQuantity)="onChangeQuantity($event)"
        [quantityOptions]="extractQuantityParameters()"></cx-configurator-attribute-quantity>
      <cx-configurator-price [formula]="extractPriceFormulaParameters()"></cx-configurator-price>
    </div>

    <udex-tile
      class="form-check"
      *ngFor="let value of attribute.values"
      [class.disabled]="(hasPendingChangesService.hasPendingChanges() | async) || null"
      [class.checked]="attributeRadioButtonForm.value === value.valueCode || null">
      <div class="cx-value-label-pair d-flex udex-my-2" (click)="onChange(value.valueCode)">
        <udex-radio-button
          value-state="None"
          [name]="createAttributeIdForConfigurator(attribute)"
          [attr.checked]="attributeRadioButtonForm.value === value.valueCode || null"
          [attr.disabled]="(hasPendingChangesService.hasPendingChanges() | async) || null"
          [attr.required]="attribute.required"
          [attr.accessibleName]="attributeRadioButtonForm.value === value.valueCode"></udex-radio-button>
        <div class="udex-mt-8 udex-pt-2 udex-pe-32">
          <div
            id="{{ createValueUiKey('label', attribute.name, value.valueCode) }}"
            class="body--s text-grey"
            [innerHtml]="value.valueDisplay"></div>
          <div *ngIf="value.description" class="form-check-label form-radio-label body--xs udex-pb-8 udex-pt-2">
            <span [innerHtml]="value.description"></span>
          </div>
        </div>
      </div>
      <div class="cx-value-price">
        <cx-configurator-price [formula]="extractValuePriceFormulaParameters(value)"></cx-configurator-price>
      </div>
    </udex-tile>
  </div>
</fieldset>

<!-- Single Selection Radio Button TRUE/FALSE (toggle) -->
<div *ngIf="isToggle(attribute)" class="switch d-flex align-content-center">
  <udex-switch color="Non-Semantic" [attr.checked]="toggleValue || null" (change)="onToggle($event)"> </udex-switch>
  <div class="udex-mx-12 text-grey body--s">
    <span *ngIf="toggleValue">{{ 'configurator.on' | cxTranslate }}</span>
    <span *ngIf="!toggleValue">{{ 'configurator.off' | cxTranslate }}</span>
  </div>
  <dcp-icon-button-tooltip
    *ngIf="getToggleTooltipText()?.length"
    class="udex-me-2 text-grey"
    [placement]="'Right'"
    [openOnClick]="true"
    [noPaddings]="true">
    <span [innerHtml]="getToggleTooltipText()"></span>
  </dcp-icon-button-tooltip>
</div>
